import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { ReactNode } from 'react';
import { FieldValues, Path, useController, UseControllerProps } from 'react-hook-form';
import { TextInput, TextInputProps } from 'shared/ui/controls/text-input';

interface LabourDescriptionFieldProps<T extends FieldValues>
  extends Omit<UseControllerProps<T>, 'name'>,
    Omit<FieldWrapperProps, 'children'>,
    Omit<TextInputProps, 'defaultValue' | 'name' | 'className'> {
  label?: ReactNode;
  required?: boolean;
  isSmallSize?: boolean;
  name?: Path<T>;
}

export const LabourDescriptionField = <T extends FieldValues>({
  label = 'Description',
  required = false,
  name,
  isSmallSize = false,
  ...props
}: LabourDescriptionFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    ...props,
    name: name || ('labourDescription' as Path<T>)
  });

  const { value, ...rest } = field;

  return (
    <FieldWrapper label={label} error={error} required={required}>
      <TextInput isSmallSize={isSmallSize} error={error} value={value ?? ''} {...rest} {...props} autoComplete="off" />
    </FieldWrapper>
  );
};
